import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-commercial-registeration-number',
  imports: [ReactiveFormsModule],
  templateUrl: './commercial-registeration-number.html',
  styleUrl: './commercial-registeration-number.scss',
})
export class CommercialRegisterationNumber {
  pharmacyForm = input.required<FormGroup>();
}
